var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#5C9673"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7721 4.76658C15.4139 5.15378 15.6203 5.98796 15.2332 6.62978L10.7242 14.1046C9.79792 15.6397 7.70357 15.9114 6.4653 14.5408C6.42316 14.4942 6.38431 14.4447 6.34903 14.3926L4.80531 12.1159C4.38466 11.4955 4.54654 10.6516 5.16687 10.2309C5.78721 9.81019 6.63109 9.97208 7.05174 10.5925L8.43887 12.6383L12.9091 5.22763C13.2963 4.58581 14.1304 4.37939 14.7721 4.76658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChecked);
export default __webpack_public_path__ + "static/media/circleChecked.4727dad4f798ff91718d100d33153167.svg";
export { ForwardRef as ReactComponent };